import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { deniedRedirect, homeFor } from '@/lib/routeAccess'

// Lazy-load por rota (§8.1 — guardrail Vite): cada tela puxa só o próprio chunk.
const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage.vue'),
    meta: { layout: 'bare' },
  },
  {
    path: '/acesso-seguro',
    name: 'two-factor',
    component: () => import('@/pages/TwoFactorPage.vue'),
    meta: { layout: 'bare' },
  },
  { path: '/2fa', redirect: { name: 'two-factor' } },
  { path: '/', redirect: { name: 'chamado-quadro' } },
  {
    path: '/chamado',
    name: 'chamado',
    component: () => import('@/pages/TicketsWorkspacePage.vue'),
    redirect: { name: 'chamado-quadro' },
    children: [
      {
        path: 'lista',
        name: 'inbox',
        component: () => import('@/pages/InboxPage.vue'),
        props: { embedded: true },
      },
      {
        path: 'quadro',
        name: 'chamado-quadro',
        component: () => import('@/pages/KanbanPage.vue'),
        props: { embedded: true },
      },
      {
        path: '/tickets/:id',
        name: 'ticket',
        component: () => import('@/pages/TicketModalPage.vue'),
        props: true,
      },
    ],
  },
  { path: '/kanban', redirect: { name: 'chamado-quadro' } },
  {
    path: '/implantation',
    name: 'implantation',
    component: () => import('@/pages/ImplantationPage.vue'),
    meta: { roles: ['admin'] },
  },
  { path: '/management', name: 'management', component: () => import('@/pages/admin/ManagementPage.vue'), meta: { roles: ['admin'] } },
  { path: '/accounts', name: 'accounts', component: () => import('@/pages/AccountsPage.vue'), meta: { roles: ['admin'] } },
  { path: '/admin/agents', name: 'agents', component: () => import('@/pages/admin/AgentsPage.vue'), meta: { roles: ['admin'] } },
  { path: '/admin/teams', name: 'teams', component: () => import('@/pages/admin/TeamsPage.vue'), meta: { roles: ['admin'] } },
  { path: '/admin/sla', name: 'sla', component: () => import('@/pages/admin/SlaPage.vue'), meta: { roles: ['admin'] } },
  { path: '/reports', name: 'reports', component: () => import('@/pages/ReportsPage.vue'), meta: { roles: ['admin'] } },
  // Tela "IA nas contas" OCULTA temporariamente (rota + item da sidebar).
  // Deep-link antigo cai na inbox. Pra reativar: restaurar o component/meta
  // aqui e o item 'text-ai' no AppSidebar.
  { path: '/admin/ia', redirect: { name: 'inbox' } },
  { path: '/admin/canais', name: 'channel-health', component: () => import('@/pages/admin/ChannelHealthPage.vue'), meta: { roles: ['admin'] } },
  { path: '/queue', name: 'queue', component: () => import('@/pages/QueuePage.vue'), meta: { roles: ['external'] } },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Guard: resolve o usuário atual 1x no boot; protege rotas autenticadas e
// canaliza a sessão meio-autenticada (senha ok, TOTP pendente) pro acesso seguro.
router.beforeEach(async to => {
  const auth = useAuthStore()
  if (!auth.ready) await auth.fetchMe()

  const publicRoutes = ['login', 'two-factor']

  // TOTP pendente: prende em /acesso-seguro até concluir o desafio.
  if (auth.otpPending) {
    return to.name === 'two-factor' ? true : { name: 'two-factor' }
  }
  // Sem desafio em andamento: ninguém fica em /acesso-seguro.
  if (to.name === 'two-factor') {
    return auth.isAuthenticated ? { name: homeFor(auth.profile) } : { name: 'login' }
  }

  if (!publicRoutes.includes(to.name) && !auth.isAuthenticated) {
    return { name: 'login' }
  }
  if (to.name === 'login' && auth.isAuthenticated) {
    return { name: homeFor(auth.profile) }
  }
  return deniedRedirect(to.meta, auth) || true
})

export default router
